import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { updateData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { CircularProgress, Fade, Tooltip, Chip, LinearProgress } from '@mui/material';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

const IncomeExpenseEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [formProgress, setFormProgress] = useState(0);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [itemOptions, setItemOptions] = useState([]); // Store available item options
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [amount, setAmount] = useState('');
    const [itemsList, setItemsList] = useState([]); // Store added items

    const [modalData, setModalData] = useState(null); // Modal data
    const [tableData, setTableData] = useState([]); // Table data for display

    useEffect(() => {
        fetchData('IncomeExpenseApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data;

                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });

                    setSelectedOption({
                        value: response.response_data?.MasterId ?? 1,
                        label: response.response_data?.MasterName ?? ''
                    });

                    setSelectedChildOption({
                        value: response.response_data?.PartyId ?? 1,
                        label: response.response_data?.PartyName ?? ''
                    });

                    setSelectedBank({
                        value: response.response_data?.BankId ?? 1,
                        label: response.response_data?.BankName ?? ''
                    });

                    setSelectedPaymentmethodType({
                        value: response.response_data?.PaymentType ?? 1,
                        label: response.response_data?.PaymentName ?? ''
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching Invoice Details:', error);
            });
    }, [id]);

    useEffect(() => {
        setMounted(true);
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }
        try {
            const response = await fetchData('IncomeExpenseApi', `/Master/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleInputChange = (newValue) => newValue;

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));
        if (!selectedOption) return;
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const fetchChildOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }
        try {
            // const response = await fetchData('JournelEntryAPI', `${companyId}/${branchId}`, token);
            const response = await fetchData('JournelEntryAPI', `/Master/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setchildOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleChildInputChange = (newValue) => newValue;

    // Handle customer selection//
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);
        setFormData((prevData) => ({
            ...prevData,
            PartyId: selectedChildOption ? selectedChildOption.value : '',
            CreatedBy: userId,
        }));
        if (!selectedChildOption) return;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState(true); // Default to Credit (true)
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: '',
        IsType: true, // 1 for Credit, 2 for Debit
    });

    // Calculate form progress
    useEffect(() => {
        const requiredFields = [
            formData.MasterId,
            formData.Amount,
            formData.PaymentType
        ];
        const filledFields = requiredFields.filter(field => field && field !== 0).length;
        const progress = (filledFields / requiredFields.length) * 100;
        setFormProgress(Math.round(progress));
    }, [formData.MasterId, formData.Amount, formData.PaymentType]);

    const submitData = async (e) => {
        e.preventDefault(); // Prevent form submission
        setIsLoading(true); // Set loading state

        if (!formData.MasterId || formData.MasterId === 0) {
            setErrorMessage('Master is required!');
            setIsLoading(false);
            return;
        }


        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        if (!formData.PaymentType || formData.PaymentType === 0) {
            setErrorMessage('Payment type is required');
            setIsLoading(false);
            return;
        }

        // Validation for non-cash payment types
        if (selectedPaymentmethodType && selectedPaymentmethodType.label !== 'Cash') {
            if (!formData.ChequeNumber) {
                setErrorMessage('Reference No is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.ChequeDate) {
                setErrorMessage('Reference Date is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.chequeDetails) {
                setErrorMessage('Reference Details are required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!selectedBank) {
                setErrorMessage('Bank selection is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            PaymentType: selectedPaymentmethodType ? selectedPaymentmethodType.value : 1,
        };

        try {
            // API Call
            const response = await updateData('IncomeExpenseApi', `${id}`, updatedFormData, token);

            // Success Handling
            setSuccessMessage('Income Expense Updated Successfully!');
            setErrorMessage('');
            setFormData({
                ...formData,
                BillDate: '',
                BillNo: 0,
                CustomerId: '',
                PaymentType: '',
                Amount: 0,
                Remarks: '',
                IsType: null,
            });
            setItemsList([]); // Clear the items list
            setIsLoading(false);
            history.push('/IncomeExpenseIndex'); // Redirect to Receipt Index

            // Reset success message after timeout
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        } catch (error) {
            console.error('Incom eExpense Creation Error:', error);

            // Detailed Error Logging
            if (error.response) {
                console.error('Response Data:', error.response.data);
                console.error('Response Status:', error.response.status);
            } else if (error.request) {
                console.error('No Response Received:', error.request);
            } else {
                console.error('Error Setting up Request:', error.message);
            }

            // Show Error Message
            setErrorMessage('Failed to update Income Expense. Please try again.');
            setIsLoading(false);
        }
    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));

        let ispaymentType = true;

        if (name === "IsType") {
            ispaymentType = value === "1";
            setSelectedPaymentType(ispaymentType);
            fetchData('IncomeExpenseApi', `/MaxBillno/${companyId}/${branchId}/${ispaymentType}`, token)
                .then((response) => response.response_data)
                .then((data) => {
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        BillNo: data.BillNumber,
                        BillDate: formattedDate,
                        FinYear: data.FinYear,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching Max Billno:', error);
                });
        } else {

        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            ChequeDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);

    // Function to fetch MaxBillno
    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('IncomeExpenseApi', `/MaxBillno/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNo: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);

    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        let amt = parseAndFix(formData.Amount);
        const GSTRate = parseAndFix(formData.GSTRate);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;
        if (formData.IsIGST) {
            igstAmount = ((amt * GSTRate) / 100).toFixed(2);
        } else {
            cgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
            sgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
        }
        let netAmount = parseAndFix(amt) + parseAndFix(igstAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount);
        //let roundOff = Math.round(netAmount) - netAmount;
        // let grandTotal = netAmount + roundOff;
        let grandTotal = netAmount;

        setFormData((prev) => ({
            ...prev,
            Amount: amt,
            CGSTAmount: parseFloat(cgstAmount).toFixed(2),
            SGSTAmount: parseFloat(sgstAmount).toFixed(2),
            IGSTAmount: parseFloat(igstAmount).toFixed(2),
            //RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    }, [formData.Amount, formData.GSTRate, formData.IsIGST]);

    //customer Payment Method 
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");
    const [showBankField, setShowBankField] = useState(true);

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentApi', `/PaymentModes/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
                setShowBankField(true);
            }
        } catch (error) {
            console.error('Error fetching PaymentModes:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            PaymentType: selectedOption.value,
        }));
        if (["Cheque", "RTGS", "NEFT", "UPI"].includes(selectedOption.label)) {
            setShowBankField(false);
        } else {
            setShowBankField(true);
        }
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    return (
        <Fade in={mounted} timeout={800}>
            <div style={{
                minWidth: '100%',
                background: '#f5f7fa',
                padding: '10px',
                position: 'relative'
            }}>
                <style>{`
                    @keyframes slideIn {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .input-field {
                        transition: all 0.3s ease;
                        border: 2px solid transparent;
                    }
                    .input-field:focus {
                        border-color: #667eea;
                        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                        transform: translateY(-2px);
                    }
                    .input-field:hover {
                        border-color: #e0e0e0;
                    }
                    .action-button {
                        transition: all 0.3s ease;
                        text-transform: none;
                        font-weight: 600;
                        letter-spacing: 0.5px;
                    }
                    .action-button:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
                    }
                    .section-card {
                        animation: slideIn 0.6s ease-out forwards;
                        opacity: 0;
                    }
                    .section-card:nth-child(1) { animation-delay: 0.1s; }
                    .section-card:nth-child(2) { animation-delay: 0.2s; }
                    @keyframes shimmer {
                        0% { background-position: -1000px 0; }
                        100% { background-position: 1000px 0; }
                    }
                    .shimmer {
                        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
                        background-size: 1000px 100%;
                        animation: shimmer 2s infinite;
                    }
                `}</style>

                <div style={{
                    maxWidth: '1400px',
                    margin: '0 auto',
                    background: 'white',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    padding: '12px',
                    position: 'relative'
                }}>
                    {/* Progress Bar */}
                    <LinearProgress
                        variant="determinate"
                        value={formProgress}
                        style={{
                            height: '3px',
                            borderRadius: '4px 4px 0 0',
                            background: '#e0e0e0',
                            marginBottom: '10px'
                        }}
                        sx={{
                            '& .MuiLinearProgress-bar': {
                                background: formProgress === 100
                                    ? 'linear-gradient(90deg, #11998e 0%, #38ef7d 100%)'
                                    : 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                                transition: 'all 0.5s ease'
                            }
                        }}
                    />

                    {/* Header Section */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '1px solid #f0f0f0'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                padding: '8px',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 8px rgba(102, 126, 234, 0.3)'
                            }}>
                                <AccountBalanceWalletIcon style={{ fontSize: '22px', color: 'white' }} />
                            </div>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h1 style={{
                                        fontSize: '20px',
                                        fontWeight: '700',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        margin: 0,
                                        letterSpacing: '-0.3px'
                                    }}>
                                        Edit Income & Expense
                                    </h1>
                                    <Tooltip title="Complete all required fields marked with *" arrow placement="right">
                                        <InfoIcon style={{ fontSize: '16px', color: '#667eea', cursor: 'pointer' }} />
                                    </Tooltip>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '4px' }}>
                                    <p style={{ margin: 0, color: '#666', fontSize: '11px' }}>
                                        Update income or expense transactions
                                    </p>
                                    <Chip
                                        icon={<CheckCircleIcon style={{ fontSize: '14px' }} />}
                                        label={`${formProgress}% Complete`}
                                        size="small"
                                        style={{
                                            height: '20px',
                                            fontSize: '10px',
                                            fontWeight: '600',
                                            background: formProgress === 100 ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {/* Income/Expense Toggle - Centered */}
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center',
                            marginTop: '12px',
                            marginBottom: '12px'
                        }}>
                            <div style={{ 
                                display: 'flex', 
                                gap: '3px', 
                                alignItems: 'center',
                                background: 'rgba(255, 255, 255, 0.9)',
                                padding: '3px',
                                borderRadius: '20px',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(102, 126, 234, 0.15)'
                            }}>
                                <label style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: '5px', 
                                    cursor: 'pointer',
                                    padding: '4px 14px',
                                    borderRadius: '18px',
                                    transition: 'all 0.3s ease',
                                    background: formData.IsType === true 
                                        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                                        : 'transparent',
                                    boxShadow: formData.IsType === true 
                                        ? '0 3px 10px rgba(102, 126, 234, 0.35)' 
                                        : 'none',
                                    transform: formData.IsType === true ? 'scale(1.01)' : 'scale(1)'
                                }}>
                                    <input
                                        type="radio"
                                        name="IsType"
                                        value="1"
                                        checked={formData.IsType === true}
                                        onChange={handleChange}
                                        style={{ 
                                            display: 'none'
                                        }}
                                    />
                                    <div style={{
                                        width: '14px',
                                        height: '14px',
                                        borderRadius: '50%',
                                        border: formData.IsType === true 
                                            ? '2px solid white' 
                                            : '2px solid #667eea',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: formData.IsType === true 
                                            ? 'white' 
                                            : 'transparent',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {formData.IsType === true && (
                                            <div style={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                            }} />
                                        )}
                                    </div>
                                    <span style={{ 
                                        fontSize: '11px', 
                                        color: formData.IsType === true ? 'white' : '#667eea', 
                                        fontWeight: '700',
                                        letterSpacing: '0.2px',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        Income
                                    </span>
                                </label>
                                <label style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: '5px', 
                                    cursor: 'pointer',
                                    padding: '4px 14px',
                                    borderRadius: '18px',
                                    transition: 'all 0.3s ease',
                                    background: formData.IsType === false 
                                        ? 'linear-gradient(135deg, #ee5a6f 0%, #f29263 100%)' 
                                        : 'transparent',
                                    boxShadow: formData.IsType === false 
                                        ? '0 3px 10px rgba(238, 90, 111, 0.35)' 
                                        : 'none',
                                    transform: formData.IsType === false ? 'scale(1.01)' : 'scale(1)'
                                }}>
                                    <input
                                        type="radio"
                                        name="IsType"
                                        value="0"
                                        checked={formData.IsType === false}
                                        onChange={handleChange}
                                        style={{ 
                                            display: 'none'
                                        }}
                                    />
                                    <div style={{
                                        width: '14px',
                                        height: '14px',
                                        borderRadius: '50%',
                                        border: formData.IsType === false 
                                            ? '2px solid white' 
                                            : '2px solid #ee5a6f',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: formData.IsType === false 
                                            ? 'white' 
                                            : 'transparent',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {formData.IsType === false && (
                                            <div style={{
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #ee5a6f 0%, #f29263 100%)'
                                            }} />
                                        )}
                                    </div>
                                    <span style={{ 
                                        fontSize: '11px', 
                                        color: formData.IsType === false ? 'white' : '#ee5a6f', 
                                        fontWeight: '700',
                                        letterSpacing: '0.2px',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        Expense
                                    </span>
                                </label>
                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Tooltip title={formProgress < 100 ? "Complete required fields to update" : "Update income/expense"} arrow>
                                <span>
                                    <Button
                                        variant="contained"
                                        onClick={submitData}
                                        disabled={isLoading}
                                        startIcon={isLoading ? null : <SaveIcon />}
                                        className="action-button"
                                        style={{
                                            background: isLoading ? '#ccc' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            padding: '6px 16px',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            boxShadow: isLoading ? 'none' : '0 2px 8px rgba(102, 126, 234, 0.3)',
                                            border: 'none',
                                            minHeight: '32px',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        {isLoading && <div className="shimmer" style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            zIndex: 1
                                        }} />}
                                        <span style={{ position: 'relative', zIndex: 2 }}>
                                            {isLoading ? <CircularProgress size={16} color="inherit" /> : "Update"}
                                        </span>
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip title="Return to income/expense list" arrow>
                                <Button
                                    variant="outlined"
                                    component={Link}
                                    to={{
                                        pathname: "/IncomeExpenseIndex",
                                        state: { from: "/IncomeExpenseEdit" },
                                    }}
                                    onClick={() => {
                                        localStorage.setItem("shouldReload", "true");
                                    }}
                                    startIcon={<ArrowBackIcon />}
                                    className="action-button"
                                    style={{
                                        borderColor: '#667eea',
                                        color: '#667eea',
                                        padding: '6px 16px',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        borderWidth: '1.5px',
                                        minHeight: '32px'
                                    }}
                                >
                                    Back to List
                                </Button>
                            </Tooltip>
                        </div>
                    </div>

                    {/* Error/Success Messages */}
                    {errorMessage && (
                        <div style={{
                            padding: '10px',
                            marginBottom: '10px',
                            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
                            color: 'white',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontWeight: '500'
                        }}>
                            {errorMessage}
                        </div>
                    )}
                    {successMessage && (
                        <div style={{
                            padding: '10px',
                            marginBottom: '10px',
                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                            color: 'white',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontWeight: '500'
                        }}>
                            {successMessage}
                        </div>
                    )}

                    {/* Transaction Details Section */}
                    <div className="section-card" style={{
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        padding: '10px',
                        borderRadius: '10px',
                        marginBottom: '8px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {selectedOption && formData.Amount && (
                            <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'rgba(17, 153, 142, 0.9)',
                                borderRadius: '50%',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <CheckCircleIcon style={{ fontSize: '16px', color: 'white' }} />
                            </div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <AccountBalanceWalletIcon style={{ color: '#667eea', fontSize: '18px' }} />
                            <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#2d3748' }}>
                                Transaction Details
                            </h3>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Master *
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleCustomerSelect}
                                    value={selectedOption}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '34px',
                                            height: '34px',
                                            fontSize: '13px',
                                            borderRadius: '8px',
                                            border: selectedOption ? '1.5px solid #11998e' : '1.5px solid #e2e8f0',
                                            background: 'white'
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: '34px',
                                            padding: '0 10px'
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: '0',
                                            padding: '0'
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: '34px'
                                        })
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Date *
                                </label>
                                <input
                                    className="input-field"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Bill Number *
                                </label>
                                <input
                                    className="input-field"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: '#fafafa',
                                        outline: 'none',
                                        cursor: 'not-allowed'
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    GST %
                                    <input
                                        type="checkbox"
                                        name="IsIGST"
                                        checked={formData.IsIGST || false}
                                        onChange={handleChange}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <span style={{ fontSize: '10px', color: '#e53e3e' }}>IGST</span>
                                </label>
                                <select
                                    className="input-field"
                                    name="GSTRate"
                                    value={formData.GSTRate || 0}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                >
                                    <option value={0}>0</option>
                                    <option value={3}>3</option>
                                    <option value={5}>5</option>
                                    <option value={12}>12</option>
                                    <option value={18}>18</option>
                                    <option value={28}>28</option>
                                </select>
                            </div>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Amount *
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        className="input-field"
                                        type="number"
                                        value={formData.Amount}
                                        name="Amount"
                                        onChange={handleChange}
                                        style={{
                                            width: '100%',
                                            padding: '6px 10px',
                                            fontSize: '13px',
                                            borderRadius: '8px',
                                            border: formData.Amount ? '1.5px solid #11998e' : '1.5px solid #e2e8f0',
                                            background: 'white',
                                            outline: 'none',
                                            fontWeight: '500',
                                            textAlign: 'right'
                                        }}
                                    />
                                    {formData.Amount && (
                                        <CheckCircleIcon style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            fontSize: '16px',
                                            color: '#11998e'
                                        }} />
                                    )}
                                </div>
                            </div>
                        </div>
                        
                        {/* GST Summary */}
                        <div style={{ 
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, 1fr)',
                            gap: '12px', 
                            marginTop: '10px',
                            padding: '10px 16px',
                            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
                            borderRadius: '10px',
                            border: '1px solid rgba(102, 126, 234, 0.15)',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.04)'
                        }}>
                            <div style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                background: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)'
                            }}>
                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    CGST:
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: '700', color: '#e53e3e' }}>
                                    {formData.CGSTAmount || '0.00'}
                                </span>
                            </div>
                            <div style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                background: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)'
                            }}>
                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    SGST:
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: '700', color: '#e53e3e' }}>
                                    {formData.SGSTAmount || '0.00'}
                                </span>
                            </div>
                            <div style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                background: 'white',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)'
                            }}>
                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#718096', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    IGST:
                                </span>
                                <span style={{ fontSize: '14px', fontWeight: '700', color: '#e53e3e' }}>
                                    {formData.IGSTAmount || '0.00'}
                                </span>
                            </div>
                            <div style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '8px',
                                boxShadow: '0 3px 8px rgba(102, 126, 234, 0.3)'
                            }}>
                                <span style={{ fontSize: '11px', fontWeight: '600', color: 'rgba(255, 255, 255, 0.9)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Total:
                                </span>
                                <span style={{ fontSize: '16px', fontWeight: '800', color: 'white' }}>
                                    {formData.TotalAmount || '0.00'}
                                </span>
                            </div>
                        </div>

                        {/* Party and Remarks */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Party
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchChildOptions}
                                    onInputChange={handleChildInputChange}
                                    onChange={handleChildSelect}
                                    value={selectedChildOption}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '34px',
                                            height: '34px',
                                            fontSize: '13px',
                                            borderRadius: '8px',
                                            border: '1.5px solid #e2e8f0',
                                            background: 'white'
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: '34px',
                                            padding: '0 10px'
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: '0',
                                            padding: '0'
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: '34px'
                                        })
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Remarks
                                </label>
                                <input
                                    className="input-field"
                                    type="text"
                                    value={formData.Remarks}
                                    name="Remarks"
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Payment Details Section */}
                    <div className="section-card" style={{
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        padding: '10px',
                        borderRadius: '10px',
                        marginBottom: '8px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <AccountBalanceWalletIcon style={{ color: '#667eea', fontSize: '18px' }} />
                            <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#2d3748' }}>
                                Payment Details
                            </h3>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px' }}>
                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    Payment Mode *
                                </label>
                                <Select
                                    value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}
                                    onChange={handlePaymentTypeChange}
                                    options={paymentmethodOptions}
                                    placeholder="Payment Option"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '34px',
                                            height: '34px',
                                            fontSize: '13px',
                                            borderRadius: '8px',
                                            border: selectedPaymentmethodType ? '1.5px solid #11998e' : '1.5px solid #e2e8f0',
                                            background: 'white'
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: '34px',
                                            padding: '0 10px'
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: '0',
                                            padding: '0'
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: '34px'
                                        })
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Bank' : 'Bank'}
                                </label>
                                <Select
                                    value={selectedBank || { value: '', label: 'Select Bank' }}
                                    onChange={handleBankChange}
                                    options={bankOptions}
                                    placeholder="Select Bank"
                                    isSearchable
                                    isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '34px',
                                            height: '34px',
                                            fontSize: '13px',
                                            borderRadius: '8px',
                                            border: '1.5px solid #e2e8f0',
                                            background: 'white'
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: '34px',
                                            padding: '0 10px'
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: '0',
                                            padding: '0'
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: '34px'
                                        })
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                </label>
                                <input
                                    className="input-field"
                                    value={formData.ChequeNumber}
                                    type="text"
                                    placeholder=""
                                    name="ChequeNumber"
                                    onChange={handleChange}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1') ? '#fafafa' : 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                </label>
                                <input
                                    className="input-field"
                                    value={formatDateForInput(formData.ChequeDate)}
                                    type="date"
                                    placeholder=""
                                    name="ChequeDate"
                                    onChange={handleChange}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1') ? '#fafafa' : 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#4a5568',
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.3px',
                                    display: 'block'
                                }}>
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                </label>
                                <input
                                    className="input-field"
                                    value={formData.chequeDetails}
                                    type="text"
                                    placeholder=""
                                    name="chequeDetails"
                                    onChange={handleChange}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                    style={{
                                        width: '100%',
                                        padding: '6px 10px',
                                        fontSize: '13px',
                                        borderRadius: '8px',
                                        border: '1.5px solid #e2e8f0',
                                        background: showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1') ? '#fafafa' : 'white',
                                        outline: 'none',
                                        fontWeight: '500'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '12px 20px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '16px',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                    fontFamily: 'serif',
                    fontWeight: '600',
                    color: '#2c3e50',
                    fontSize: '13px',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    zIndex: 1000
                }}>
                    <CopyrightIcon style={{ fontSize: '18px', color: '#667eea' }} />
                    <span>EFFTABS SOLUTIONS LLP</span>
                </div>
            </div>
        </Fade>
    );
};

export default IncomeExpenseEdit;
